import type { User } from "@/lib/types";

type ProfileFieldCheck = Pick<
  User,
  | "phone"
  | "gender"
  | "name"
  | "location"
  | "location_state_id"
  | "location_lga_id"
  | "location_neighborhood_id"
>;

/** Required profile fields (without relying on `is_profile_complete` flag). */
export function hasRequiredProfileFields(u: ProfileFieldCheck): boolean {
  return (
    Boolean(u.phone) &&
    Boolean(u.gender) &&
    Boolean(u.name) &&
    Boolean(u.location) &&
    Boolean(u.location_state_id) &&
    Boolean(u.location_lga_id) &&
    Boolean(u.location_neighborhood_id) &&
    (u.name?.split(/\s+/).filter(Boolean).length ?? 0) >= 2
  );
}

/** Same rules as ProfileCompletionGuard / complete-profile redirect. */
export function isProfileCompleteForAccess(
  u: Pick<User, "is_profile_complete"> & ProfileFieldCheck,
): boolean {
  return u.is_profile_complete === true && hasRequiredProfileFields(u);
}
